import repository from '@/repositories/repository'
const resource = 'recieved-inventories'
export default {
  export () {
    return repository.get(`${resource}/export`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resource}/import`, { data, columns, unique })
  },
  storeIndex (storeId, params) {
    return repository.get(`${resource}/store/${storeId}`, { params })
  },
  receiptCount (params) {
    return repository.get(`${resource}/receipts/count`, { params })
  },
  receipts (params) {
    return repository.get(`${resource}/receipts`, { params })
  },
  storeIndexAll (storeId, params) {
    return repository.get(`${resource}/store/${storeId}/all`, { params })
  },
  storeCount (storeId, params) {
    return repository.get(`${resource}/store/${storeId}/count`, { params })
  },
  totalAmount () {
    return repository.get(`${resource}/total`)
  },
  update (id, data) {
    return repository.put(`${resource}/${id}`, data)
  },
  store (data) {
    return repository.post(`${resource}`, { data })
  },
  countExport () {
    return repository.get(`${resource}/export/count`)
  },
  weeklyBranch (storeId, params) {
    return repository.get(`${resource}/summary/weekly/${storeId}`, { params })
  },
  monthlyBranch (storeId, params) {
    return repository.get(`${resource}/summary/monthly/${storeId}`, { params })
  },
  yearlyBranch (storeId, params) {
    return repository.get(`${resource}/summary/yearly/${storeId}`, { params })
  },
  weeklyAll (params) {
    return repository.get(`${resource}/summary/all/weekly`, { params })
  },
  monthlyAll (params) {
    return repository.get(`${resource}/summary/all/monthly`, { params })
  },
  yearlyAll (params) {
    return repository.get(`${resource}/summary/all/yearly`, { params })
  },
}
